import Alpine from 'alpinejs';

// Make Alpine available globally
window.Alpine = Alpine;

// Custom Alpine components
Alpine.data('navigation', () => ({
  isOpen: false,
  toggle() {
    this.isOpen = !this.isOpen;
  },
  close() {
    this.isOpen = false;
  }
}));

Alpine.data('testimonialSlider', () => ({
  currentSlide: 0,
  slides: [],
  autoplayInterval: null,
  
  init() {
    this.slides = this.$el.querySelectorAll('[data-slide]');
    this.startAutoplay();
  },
  
  next() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  },
  
  prev() {
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
  },
  
  goToSlide(index) {
    this.currentSlide = index;
  },
  
  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.next();
    }, 5000);
  },
  
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
}));

Alpine.data('contactForm', () => ({
  formData: {
    name: '',
    email: '',
    phone: '',
    message: '',
    service: ''
  },
  isSubmitting: false,
  submitSuccess: false,
  submitError: false,
  
  async submitForm() {
    this.isSubmitting = true;
    this.submitError = false;
    
    try {
      const response = await fetch(du_2025_ajax.ajax_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          action: 'du_2025_contact_form',
          nonce: du_2025_ajax.nonce,
          ...this.formData
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        this.submitSuccess = true;
        this.formData = { name: '', email: '', phone: '', message: '', service: '' };
      } else {
        this.submitError = result.data.message || 'An error occurred. Please try again.';
      }
    } catch (error) {
      this.submitError = 'Network error. Please check your connection and try again.';
    } finally {
      this.isSubmitting = false;
    }
  }
}));

Alpine.data('savingsCalculator', () => ({
  currentBill: 0,
  estimatedSavings: 0,
  
  calculateSavings() {
    // Simple calculation - can be enhanced with real data
    this.estimatedSavings = Math.round(this.currentBill * 0.15);
  }
}));

// Utility functions
const utils = {
  // Smooth scroll to element
  scrollToElement(elementId, offset = 0) {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  },
  
  // Intersection Observer for animations
  observeElements(selector, options = {}) {
    const defaultOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observerOptions = { ...defaultOptions, ...options };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    document.querySelectorAll(selector).forEach(el => {
      observer.observe(el);
    });
  },
  
  // Debounce function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },
  
  // Format currency
  formatCurrency(amount, currency = 'EUR') {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currency
    }).format(amount);
  }
};

// Make utils available globally
window.duUtils = utils;

// Initialize Alpine
Alpine.start();

// DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize intersection observer for animations
  utils.observeElements('.animate-on-scroll');
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      utils.scrollToElement(targetId, 80);
    });
  });
  
  // Mobile menu close on outside click
  document.addEventListener('click', (e) => {
    const mobileMenu = document.querySelector('[x-data*="navigation"]');
    const mobileMenuButton = document.querySelector('[x-on:click*="toggle"]');
    
    if (mobileMenu && mobileMenuButton && !mobileMenu.contains(e.target) && !mobileMenuButton.contains(e.target)) {
      Alpine.store('navigation', { isOpen: false });
    }
  });
  
  // Lazy loading for images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          imageObserver.unobserve(img);
        }
      });
    });
    
    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
  
  // WhatsApp integration
  const whatsappButtons = document.querySelectorAll('.whatsapp-btn');
  whatsappButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const message = button.dataset.message || 'Hi Dave, I\'d like to learn more about saving on my utility bills!';
      const phone = button.dataset.phone || '+353123456789';
      const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    });
  });
});

// Performance monitoring
if ('performance' in window) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const perfData = performance.getEntriesByType('navigation')[0];
      if (perfData && perfData.loadEventEnd - perfData.loadEventStart > 3000) {
        console.warn('Page load time is slow:', perfData.loadEventEnd - perfData.loadEventStart, 'ms');
      }
    }, 0);
  });
} 